import { MAX_SPRINT_NAME_CHARS, sanitizeSprintName } from "../sprintName";

export const SPRINT_CHIP_AVG_CHAR_PX = 7;
export const SPRINT_CHIP_HORIZONTAL_PADDING = 18;
export const SPRINT_CHIP_TEXT_MARGIN = 8;
export const SPRINT_CHIP_MIN_LABEL_TEXT_PX = 12;
export const SPRINT_CHIP_MAX_WIDTH_PX = 240;

export function fitLabelToWidth(name: unknown, widthPx: unknown) {
  const safeName = sanitizeSprintName(name);
  const n = widthPx === null || widthPx === undefined || widthPx === "" ? null : Number(widthPx);
  const safeWidth = Math.max(0, Number.isFinite(n) ? n : 0);
  const maxCharsByWidth = Math.floor(safeWidth / SPRINT_CHIP_AVG_CHAR_PX);

  if (safeWidth < SPRINT_CHIP_MIN_LABEL_TEXT_PX || maxCharsByWidth < 1) {
    return { text: "", truncated: false, hidden: true };
  }

  if (maxCharsByWidth < 2) {
    return { text: "…", truncated: true, hidden: false };
  }

  const maxChars = Math.max(6, Math.min(MAX_SPRINT_NAME_CHARS, maxCharsByWidth));
  if (safeName.length <= maxChars) {
    return { text: safeName, truncated: false, hidden: false };
  }

  const visibleChars = Math.max(1, maxChars - 1);
  return { text: `${safeName.slice(0, visibleChars)}…`, truncated: true, hidden: false };
}
